// Foundations
import { Component, OnInit } from '@angular/core';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { BookingService } from 'src/app/services/booking.service';

@Component({
  selector: 'app-bookings-list',
  templateUrl: './bookings-list.component.html',
  styleUrls: ['./bookings-list.component.scss'],
})
export class BookingsListComponent implements OnInit {
  constructor(
    private _analytics: AnalyticsService,
    public bookingService: BookingService
  ) {}

  ngOnInit() {
    this.bookingService.fetchBookings(true);
    this._analytics.logScreen('upcomingBookingPage');
  }
}
